<script>
import feather from 'feather-icons';

export default {
  name: 'Home',
  data: () => {
    return {
      theme: '',
    };
  },
  created() {
    this.theme = localStorage.getItem('theme') || 'light';
  },
  mounted() {
    feather.replace();
    this.theme = localStorage.getItem('theme') || 'light';
  },
  updated() {
    feather.replace();
  },
  methods: {},
};
</script>

<template>
  <section class="relative banner-section">
    <!-- Hero image container positioned relative to the section -->
    <div class="hero-background">
      <img
        src="@/assets/images/SF_HERO.png"
        alt="Background Hero"
        class="hero-image"
      />
    </div>
    
    <div class="relative z-10 flex flex-col sm:justify-between items-center sm:flex-row sm:gap-8 mt-12 sm:mt-10">
      <!-- Banner left contents -->
      <div class="w-full md:w-1/2 text-left">
        <h1
          class="font-general-semibold text-3xl md:text-3xl xl:text-4xl text-center sm:text-left text-ternary-dark dark:text-primary-light uppercase"
        >
          Welcome to Avakot!
        </h1>
        <p
          class="font-general-medium mt-2 text-lg sm:text-xl xl:text-2xl text-center sm:text-left leading-none text-gray-400"
        >
          A Community project that aims to bring together awesome community made tools for Soulframe!
        </p>
        <div class="flex justify-center sm:block">
          <a
            href="https://discord.gg/WWEf2cM4eu"
            target="_blank"
            rel="noopener noreferrer"
            class="flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
            aria-label="Discord"
          >
            <i
              data-feather="arrow-down-circle"
              class="ml-0 sm:ml-1 mr-2 sm:mr-3 w-5 sm:w-6 duration-100"
            ></i>
            <span class="text-sm sm:text-lg font-general-medium duration-100">Discord</span>
          </a>
        </div>
      </div>
      
      <!-- Empty div to maintain layout space on the right -->
      <div class="w-full md:w-1/2"></div>
    </div>
  </section>
</template>

<style scoped>
.banner-section {
  position: relative;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  z-index: 1;
  pointer-events: none; /* Allows clicking through the image */
}

.hero-image {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%) scale(1.5); /* Increased size by 50% */
  max-height: 100%;
  object-fit: contain;
  transform-origin: right center; /* Keep the right edge anchored */
}
</style>
